import React, {Component} from 'react';
import classNames from 'classnames';
import 'react-select/dist/react-select.css';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import MultistepSelect from '../multistep-select/MultistepSelect';
import MultipleSelectedListNested from '../multistep-select/MultipleSelectedListNested';
import NestedUtils from './../multistep-select/NestedUtils';
import _ from 'lodash';
import DisabledSelectedListNested from "../multistep-select/DisabledSelectedListNested";

const MultistepSelectFormAdapter = (props) => {

    const {
        label = props.intl.formatMessage(messages.category),
        selectedListComponent = MultipleSelectedListNested,
        disabledListComponent = DisabledSelectedListNested,
        renderLabel,
        disableParentSelect
    } = props;

    function getIdValue(value) {
        let outputValuesKey = props.outputValuesKey || 'id';
        if((value instanceof Object) && value.custom) {
            return value[outputValuesKey];
        }

        if(!props.outputValuesKey) {
            return value;
        }

        let nestedUtils = new NestedUtils(props.data);
        const item = nestedUtils.findItemById(value);

        return item[outputValuesKey];
    }

    return (
        <div className={classNames('form-group row', {'has-danger': props.meta.touched && props.meta.error})} id={`div_${props.input.name}`}>
            <label className="col-sm-2 col-form-label">
                {renderLabel ? renderLabel() : <b>{label}</b>}
            </label>
            <div className="col-sm-10">
                <MultistepSelect
                    {...props}
                    selection={props.input.value}
                    onConfirm={
                        value => {
                            let selection = _.union(props.input.value, [getIdValue(value)]);
                            props.onConfirm && props.onConfirm(selection);
                            return props.input.onChange(selection);
                        }
                    }
                    onRemove={
                        value => {
                            let selection = props.input.value.filter(id => id !== value);
                            return props.input.onChange(selection);
                        }
                    }
                    selectedListComponent={selectedListComponent}
                    disabledListComponent={disabledListComponent}
                    disableParentSelect={disableParentSelect}
                />
            </div>
        </div>
    );
};

export default injectIntl(MultistepSelectFormAdapter);




// WEBPACK FOOTER //
// ./web/src/components/common/MultistepSelectFormAdapter.jsx